<template>
    <iframe :src="src" class="iframe"></iframe>
</template>
<script>
export default {
    name: 'filePreview',
    computed:{
        src(){
          if(process.env.NODE_ENV === 'native'){
            return this.$route.query.downloadUrl
          }else{
            return process.env.PREVIEW_URL + this.$route.query.downloadUrl
          }
        }
    }
}
</script>
<style scoped lang="scss">
iframe{
    width: 100vw;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_course_module/editCourse/sourceMaterial/filePreview.vue